<template>
  <div>
    <h1 class="font-family-display font-weight-bold mb-8">
      {{ $t('create_artist_account') }}
    </h1>
    <p class="mb-24">
      {{ $t('already_have_an_account') }}
      <router-link :to="{ name: 'Login' }">
        {{ $t('login') }}
      </router-link>
    </p>
    <AccountOnboardingForm is-onboarding />
  </div>
</template>

<script>
import AccountOnboardingForm from '@/components/forms/AccountOnboardingForm.vue'
import { mapActions } from 'pinia'
import { useCommonStore } from '@/stores/commonStore'

export default {
  name: 'AccountOnoboarding',
  components: {
    AccountOnboardingForm
  },
  emits: ['setStep'],

  mounted() {
    this.setActiveStep('AccountOnboarding')
  },
  updated() {
    this.setActiveStep('AccountOnboarding')
  },
  methods: {
    ...mapActions(useCommonStore, ['setActiveStep'])
  }
}
</script>
